import { SubSectionContentStack } from '@shared/components/core/layouts/CommonLayoutStyles';
import { ContentTitleThin } from '@shared/components/core/text/ContentTypography';
import { TitleSmall } from '@shared/components/core/text/Typography';
import ActivateLicenseCard from '@shared/components/license/ActivateLicenseCard';
import SplashLoader from '@shared/components/loading/SplashLoader';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPreferencesSection from './EmailPreferencesSection';
import PasswordResetSection from './PasswordResetSection';
import UserPreferencesSection from './UserPreferencesSection';
import ExpiredLicenseCard from '@shared/components/license/ExpiredLicenseCard';

export default function AccountSettingPageContent() {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const currentUserContainer = CurrentUserContainer.useContainer();

    useEffect(() => {
        const fetchUserData = async () => {
            await currentUserContainer.loadCurrentUser();
            setIsLoading(false);
        };

        fetchUserData();
    }, []);

    if (isLoading) {
        return <SplashLoader />;
    }

    return (
        <>
            <SubSectionContentStack>
                <ContentTitleThin as="p">
                    {t('common:account.usernameLabel')}{' '}
                    <TitleSmall as="span">{currentUserContainer.currentUser?.username}</TitleSmall>
                </ContentTitleThin>
                <ContentTitleThin as="p">
                    {t('common:account.emailLabel')}{' '}
                    <TitleSmall as="span">{currentUserContainer.currentUser?.email}</TitleSmall>
                </ContentTitleThin>
            </SubSectionContentStack>

            {currentUserContainer.hasNoOrgMemberships ? <ActivateLicenseCard /> : <ExpiredLicenseCard />}
            <PasswordResetSection />
            <EmailPreferencesSection />
            <UserPreferencesSection />
        </>
    );
}
